import React, { Component } from 'react';
import PageHelmet from './Helmet';
import Breadcrumb from './Breadcrumb';
import CounterOne from './CounterOne';
import Testimonial from './Testimonial';
import BrandTwo from './BrandTwo';
import { FaFacebookF, FaLinkedinIn, FaTwitter } from 'react-icons/fa';
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from 'react-icons/fi';
import Header from '../../../Layout/Main/header/Header';
import Footer from '../../../Layout/Main/footer/FooterTwo';

class LargeAndHeavy extends Component {
	render() {
		let title = 'Large and Heavy Items',
			description = (
				<p>
					oving your household materials from one location to another location is such a stress. Moonline is there to help you. We will provide a discount to customers who refer us to friends and family. You can also trust Moonline by seeing our hundreds of positive moving reviews and
					satisfied customers. When you move to another place, transporting large and bulky items without damaging them or without injuring yourself is always a challenge Heavy and large Items may include
					<ul>
						<li>Bedroom sets</li>
						<li>Bookshelves</li>
						<li>Antiques</li>
						<li>Sofas</li>
						<li>Swings</li>
						<li>Bicycles</li>
						<li>Desks</li>
					</ul>
					If you are worried about moving your heavy material, then hire Moonline to take care of the job. You can trust Moonline for the following reasons:
				</p>
			);
		return (
			<React.Fragment>
				<PageHelmet pageTitle='Large and Heavy Items' />

				<Header headertransparent='header--transparent' colorblack='color--black' logoname='logo.png' />
				{/* Start Breadcrump Area */}
				{/* End Breadcrump Area */}

				{/* Start About Area  */}
				<div className='rn-about-area ptb--120 bg_color--1'>
					<div className='rn-about-wrapper'>
						<div className='container'>
							<div className='row row--35 align-items-center'>
								<div className='col-lg-7'>
									<div className='about-inner inner'>
										<div className='section-title'>
													<Breadcrumb title={'Large and Heavy Items'} />
											<h2 className='title'>{title}</h2>
											<p className='description'>{description}</p>
										</div>
										<div className='row mt--30'>
											<div className='col-lg-12 col-md-12 col-sm-12 col-12'>
												<div className='about-us-list'>
													<h3 className='title'>Safely move your equipment</h3>
													<p>
														Our movers have the skillset required to safely move your heavy items no matter what. Whether you are moving a bulky copy machine from your office or a solid wood sofa from your residence, our trained movers have helped hundreds of individuals
														and business owners across the province.
													</p>
													<p>
														In case of business, your office equipment is one of the essential parts of your business. That's why you can't afford to get the damage. If you want all your office equipment not to get damaged while moving, then hire Moonline. Our team
														members are so professional that they know how to move electronic equipment and any piece of office furniture with ease and protection. Moreover, we use the right moving and packing material that will keep your belongings safe.
													</p>
												</div>
											</div>
											<div className='col-lg-12 col-md-12 col-sm-12 col-12'>
												<div className='about-us-list'>
													<h3 className='title'>Moving without missing</h3>
													<p>
														When you move your belongings, including your home and business material in one day, it is challenging to have an eye on everything during moving. To avoid missing out an item or two, you may contact Moonline. We will make sure nothing of your
														affects is missing. Using our years of experience and exceptional expertise, we will have an eye on everything that has chances to be misplaced.{' '}
													</p>

													<h3 className='title'>Save your business time.</h3>

													<p>When you your business from its current location to another, no doubt your business operation may be interrupted. It is always a smart choice to leave this job to a professional mover such as Moonline.</p>
													<p>In business, time is money, and we understand the importance of time. So to save time, headache, and stress, you may contact us for your next move.</p>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				{/* Start Back To Top */}
				<div className='backto-top'>
					<ScrollToTop showUnder={160}>
						<FiChevronUp />
					</ScrollToTop>
				</div>
				{/* End Back To Top */}

				<Footer />
			</React.Fragment>
		);
	}
}
export default LargeAndHeavy;
